import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 700px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.menuPrimaryDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.3;
    margin: 0 0 30px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const WrapperForm = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 40px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 32px;
    }
  `}
`;

export const Row = styled.div``;

export const Label = styled.div`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    gap: 8px;
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0;
  `};
`;

export const SmallText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
  `};
`;

export const LabelDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;
    margin: 8px 0 0;
  `};
`;

export const WrapperInput = styled.div`
  margin-top: 16px;
  position: relative;
`;

export const ButtonImproveDescription = styled.div`
  ${({ theme }) => css`
    margin-top: 16px;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      bottom: -2px;
      margin-top: 0;
      position: absolute;
      right: 16px;
    }
  `}
`;

export const ButtonText = styled.div`
  button {
    gap: 8px;

    svg {
      flex: 0 0 16px;
    }
  }
`;

export const WrapperDescriptionExample = styled.div`
  margin-top: 24px;
`;

export const DescriptionExampleContent = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 16px;
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: 1.5;
    margin-top: 16px;
    padding: 16px;

    span {
      font-weight: ${theme.v2.font.weights.medium};
    }
  `};
`;

export const InputsListContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 24px;
    margin-top: 24px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `};
`;

export const InputContainerPhone = styled.div`
  ${({ theme }) => css`
    width: 40%;
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const InputContainerEmail = styled.div`
  ${({ theme }) => css`
    width: 56%;
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const ToneOfVoiceContainer = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-top: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(2, 1fr);
    }
  `}
`;

export const ToneOfVoiceOptionIcon = styled.div``;

export const ToneOfVoiceOption = styled.div`
  ${({ theme, active }) => css`
    align-items: center;
    background-color: ${active ? theme.v2.colors.brand.primaryUltraLight : 'transparent'};
    border: 1px solid ${active ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.brand.primaryLowLight};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex: 1;
    }
  `}
`;

export const ToneOfVoiceOptionLabel = styled.div`
  ${({ theme, active }) => css`
    color: ${active ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
    text-align: center;
  `}
`;

export const ButtonWrapper = styled.div`
  margin-top: 32px;
`;
